import {AbstractModule} from "../AbstractModule";
import {OvereasProcessor} from "../OvereasProcessor";

export class AdminTable extends AbstractModule {
    constructor(plugin: OvereasProcessor) {
        super(plugin);
        this.addButtonEvents();
        this.addFormEvents();
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected addButtonEvents() {
        this.plugin.$("#os-request-payout").on("click", (event) => {
            if (this.plugin.getAdminConfig().canRequestPayout !== true || this.plugin.$(".wp-list-table tr").hasClass("no-items") === true) {
                this.plugin.window.alert(this.plugin.getAdminConfig().tr.noPayoutRequestPossible);
                return;
            }
            if (this.plugin.window.confirm(this.plugin.getAdminConfig().tr.confirmPayout) === false)
                return;
            let url = this.plugin.window.document.location.href;
            url = this.webHelpers.addParamToUrl(url, "overs-payout", "1");
            this.plugin.window.location.href = url;
        });
    }

    protected addFormEvents() {
        /*
        this.plugin.$("#os-date-selection").on("change", (event) => {
            let url = this.plugin.window.document.location.href;
            url = this.webHelpers.addParamToUrl(url, "overs-date", this.plugin.$(event.target).val(), true);
            this.plugin.window.location.href = url;
        });
         */
        this.plugin.$("#os-show-date-range").on("click", (event) => {
            const minDays = this.plugin.getAdminConfig().minDaysTable;
            if (this.webHelpers.isValidDatepickerRange("#os-date-from", "#os-date-to", minDays*24*60*60*1000) === false) {
                this.plugin.window.alert(this.plugin.getAdminConfig().tr.invalidDateRange.
                    replace("{days}", "" + minDays));
                return;
            }
            let url = this.plugin.window.document.location.href;
            // val() would return the string value
            let from = this.webHelpers.getDatepickerTimestamp("#os-date-from");
            let to = this.webHelpers.getDatepickerTimestamp("#os-date-to");
            url = this.webHelpers.addParamToUrl(url, "overs-date-from", "" + from, true);
            url = this.webHelpers.addParamToUrl(url, "overs-date-to", "" + to, true);
            this.plugin.window.location.href = url;
        });
        this.plugin.$("")
    }
}
